<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import tool from './common/tool.js';
	import i18n, { setLanguage } from './common/i18n/index.js';

	export default {
		onLaunch() {
			uni.removeStorageSync('class_reflush');
			uni.removeStorageSync('home_reflush');

			this.checkInfo();
			this.getSystenInfo();
			this.checkHaveLogin();

			// 屏蔽报错[Deprecation] Listener added for a 'DOMNodeInserted' mutation event. Support for this event type has been removed, and this event will no longer be fired. See https://chromestatus.com/feature/5083947249172480 for more information.
			(() => {
				const A = Node.prototype.addEventListener;
				Node.prototype.addEventListener = function (t, l, o) { if (t === 'DOMNodeInserted') return; return A.call(this, t, l, o); };
			})();
		},
		onShow() { },
		onHide() { },
		globalData: {
			...tool.value,
			user: {
				userId: 0,
				photo: '',
			}, // 用户信息
			systemInfo: {}, // 系统信息
			crole: {
				roleId: 0,
			}, // 当前选择的角色
			previewsource: [], // 预览的资源
			cChild: {
				childId: 0,
			}, // 当前选择的孩子
		},
		created() { },
		mounted() {
			// 禁止长按触发浏览器原生右键菜单
			document.addEventListener("contextmenu", e => e.preventDefault());
		},
		methods: {
			...tool.method,
			back() {
				const pages = getCurrentPages();
				if (pages.length === 1) {
					// 没有上一个页面
					uni.switchTab({ url: '/pages/tabbar/home/home' });
					return;
				} else if (pages.length > 1) {
					// 获取上一个页面对象
					const prevPage = pages[pages.length - 2];

					if (prevPage.route.includes('/tabbar/')) {
						// 首页跳转过来的
						uni.switchTab({ url: `/${prevPage.route}` });
					} else {
						// 非首页
						if (prevPage.route.includes('/login/')) {
							// 登录页面跳转过来的
							uni.redirectTo({ url: `/${prevPage.route}` });
						} else {
							uni.navigateBack();
						}
					}
					return;
				}
				uni.navigateBack();
			},
			checkInfo() { // 校验信息
				const user = uni.getStorageSync('user');
				if (user && user !== {}) {
					this.globalData.user = user;
				}
				if (this.globalData.user.userId === 0) {
					uni.navigateTo({ url: '/pages/login/login' });
					return false;
				}

				const role = uni.getStorageSync('role');
				if (role && role !== {}) {
					this.globalData.crole = role;
				}
				if (this.globalData.crole.roleId === 0) {
					uni.navigateTo({ url: '/pages/mine/role/role' });
					return false;
				}

				const child = uni.getStorageSync('child');
				if (child && child !== {}) {
					this.globalData.cChild = child;
				}
				if (this.globalData.cChild.childId === 0) {
					uni.navigateTo({ url: '/pages/mine/selChild/selChild' });
					return false;
				}

				return true;
			},
			checkHaveLogin() { // 检查是否登录超时
				return new Promise((resolve, reject) => {
					getApp().http('kgusermgr/index/checkHaveLogin')
						.then((res) => {
							uni.hideLoading();
							if (!res.data.result) {
								getApp().showModal(res.data.msg);
								return;
							}
						})
						.catch(console.error);
				});
			},
			getUserInfo() { // 获取用户信息
				return new Promise((resolve, reject) => {
					getApp().http('kgusermgr/index/getUser')
						.then((res) => {
							if (!res.data.result) {
								getApp().showModal(res.data.msg);
								reject(res);
								return;
							}
							let info = res.data.msg[0];
							const host = this.globalData.Host;

							const user = {
								...info,
								token: res.data.token,
								headPortraitSrc: host + info.headPortraitSrc,
								photo: host + info.photo,
							};
							this.globalData.user = user;
							uni.setStorageSync('user', user || {});
							resolve(user);
						})
						.catch(reject);
				});
			},
			getSystenInfo() {
				const DeviceInfo = uni.getDeviceInfo(),
					WindowInfo = uni.getWindowInfo(),
					AppBaseInfo = uni.getAppBaseInfo();
				this.globalData.systemInfo = {
					...DeviceInfo,
					...WindowInfo,
					...AppBaseInfo
				};
				if (this.globalData.systemInfo?.deviceType !== 'phone') {
					// 不是在手机访问
					console.log(this.globalData.systemInfo.deviceType);
				}
			},
			setLanguage,
			translate: (key, params = {}) => i18n.t(key, params),
		},
		computed: {
			currentLanguage() {
				return i18n.locale; // ✅ 获取当前语言
			}
		}
	};
</script>

<style lang="scss">

	/*每个页面公共css */
	page {
		width: 100%;
		overflow: scroll;
		-webkit-overflow-scrolling: touch;

		--theme-color1: #757de8;
		--theme-color2: #cccccc;
		--theme-color3: #333333;
		--theme-color4: #5c5c5c;
		--theme-color5: #757de8;
		--theme-color6: #3F51B5;
		--theme-color7: #dedeff;
		--theme-color8: #f5f5f5;
		--theme-color9: #2196F3;
		--theme-color10: #ffffff;
		--theme-color11: #e0e0e0;
		--theme-color12: #86878E;
		--theme-color13: #4D525E;
		--theme-color14: #000000;
		--theme-color15: #838689;
		--theme-color16: #f4212e;
		--theme-color17: #FFD400;
		--theme-color18: #12b886;
		--theme-color19: #f91880;
	}

	/* 去除scroll滚动条 */
	/* ::-webkit-scrollbar {
		display: none;
		width: 0;
		height: 0;
		color: transparent;
	} */

	html {
		font-size: 16px;
	}

	body {
		margin: 0;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
			'Droid Sans', 'Helvetica Neue', 'Microsoft Yahei', sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		-webkit-overflow-scrolling: touch;

		background:
			radial-gradient(circle at 20% 30%, rgba(247, 174, 3, 0.08) 0%, transparent 40%),
			radial-gradient(circle at 70% 20%, rgba(60, 164, 171, 0.08) 0%, transparent 50%),
			radial-gradient(circle at 30% 80%, rgba(52, 152, 104, 0.08) 0%, transparent 50%),
			radial-gradient(circle at 80% 70%, rgba(244, 88, 46, 0.05) 0%, transparent 50%),
			#ffffff;
	}

	view,
	image,
	text {
		box-sizing: border-box;
		flex-shrink: 0;
	}

	.flex-warp {
		display: flex;
		flex-wrap: wrap;
	}

	.flex {
		display: flex;
	}

	.inflex {
		display: inline-flex;
	}

	.flex-row {
		display: flex;
		flex-direction: row;
	}

	.flex-col {
		display: flex;
		flex-direction: column;
	}

	.justify-start {
		justify-content: flex-start !important;
	}

	.justify-end {
		justify-content: flex-end !important;
	}

	.justify-center {
		justify-content: center !important;
	}

	.justify-between {
		justify-content: space-between !important;
	}

	.justify-around {
		justify-content: space-around !important;
	}

	.justify-evenly {
		justify-content: space-evenly !important;
	}

	.items-start {
		align-items: flex-start !important;
	}

	.items-end {
		align-items: flex-end !important;
	}

	.items-center {
		align-items: center !important;
	}

	.self-start {
		align-self: flex-start !important;
	}

	.self-end {
		align-self: flex-end !important;
	}

	.self-center {
		align-self: center !important;
	}

	.flex-1 {
		flex: 1 1 0%;
	}

	.flex-auto {
		flex: 1 1 auto;
	}

	.flex-2 {
		flex: 2;
	}

	.flex-3 {
		flex: 3;
	}

	.flex-4 {
		flex: 4;
	}

	.flex-5 {
		flex: 5;
	}

	.flex-6 {
		flex: 6;
	}

	.flex-7 {
		flex: 7;
	}

	.flex-8 {
		flex: 8;
	}

	.flex-9 {
		flex: 9;
	}

	.shrink {
		flex-shrink: 1;
	}

	.shrink-0 {
		flex-shrink: 0;
	}

	.relative {
		position: relative;
	}

	.sticky {
		position: sticky;
	}

	.fixed {
		position: fixed;
	}

	.absolute {
		position: absolute;
	}

	.safe-top {
		padding-top: env(safe-area-inset-top) !important;
	}

	.safe-bottom {
		padding-bottom: env(safe-area-inset-bottom) !important;
	}

	.margin-top-10 {
		margin-top: 10px;
	}

	.margin-bottom-10 {
		margin-bottom: 10px;
	}

	.border-bottom-groove {
		border-bottom-style: groove;
	}

	.max-height {
		height: 100%;
	}

	.max-width {
		width: 100% !important;
	}

	.word-break {
		word-wrap: break-word;
		word-break: break-all;
		width: 100%;
	}

	.cus_search {
		margin-left: 10rpx;
		margin-top: 16rpx;
		max-width: 200rpx;
		background-color: #fff;
		border-radius: 4px;
		color: #1f2d3d;
		min-width: 110rpx;
	}

	.tabs-view {
		height: 5vh;
		background-color: #fff;
	}

	.mipage {
		width: 100%;
		min-height: calc(100vh - var(--top-window-height) - calc(44px + env(safe-area-inset-top)));
		-webkit-overflow-scrolling: touch;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.mipage .list-item:last-child {
		margin-bottom: 20rpx !important;
	}

	::v-deep .uni-button {
		white-space: nowrap !important;
		min-width: fit-content !important;
	}

	::v-deep .uni-stat__select .uni-select__input-box uni-view:has(.uni-icons.uniui-bottom, .uni-icons.uniui-top) {
		position: absolute;
		right: 0;
	}

	::v-deep .uni-tabbar {
		display: none !important;
	}

	.word-keepall {
		word-break: keep-all;
		width: 100%;
	}

	::v-deep .uni-forms-item__label uni-text {
		width: 100%;
	}

	::v-deep .uni-forms-item__label uni-text {
		width: 100%;
	}

	::v-deep .uni-group--card {
		overflow: visible !important;
	}
</style>